import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './normalize.css';
import './styles.css';
import 'react-bootstrap';
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
import Home from './Pages/Home';
import About from './Pages/About';
import Contact from './Pages/Contact';
import Projects from './Pages/Projects';
import Leads from './Pages/Leads';


function App() {
  return (
    <Router>
    <div>
      <Navbar/>
      <Switch>
      <Route path="/" exact component={Home}/>
      <Route path="/Projects" component={Projects}/>
      <Route path="/About" component={About}/>
      <Route path="/Contact" component={Contact}/>
      <Route path="/Leads" component={Leads}/>
      </Switch>
      <div>
        <Footer/>
      </div>
    </div>
    </Router>
  );
}

export default App;
